import { render, staticRenderFns } from "./staticsCard.vue?vue&type=template&id=b483ed30&scoped=true"
import script from "./staticsCard.vue?vue&type=script&lang=js"
export * from "./staticsCard.vue?vue&type=script&lang=js"
import style0 from "./staticsCard.vue?vue&type=style&index=0&id=b483ed30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b483ed30",
  null
  
)

export default component.exports